(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){const drawer=document.getElementById('hvl-navigation');const open=document.querySelector('.hvl-menu-button');if(!drawer||!open)return;let previousOverflow='';open.addEventListener('click',function(){previousOverflow=document.body.style.overflow;drawer.showModal();document.body.style.overflow='hidden';});drawer.querySelector('.hvl-close').addEventListener('click',function(){drawer.close();});drawer.addEventListener('click',function(event){if(event.target===drawer){const rect=drawer.getBoundingClientRect();if(event.clientX>rect.right||event.clientX<rect.left)drawer.close();}});drawer.addEventListener('close',function(){document.body.style.overflow=previousOverflow;open.focus();});})();

  } catch(e) { console.error(e); }
})();
})();
